<template>
  <div>
    <app-detail-header :show-toggle="false"
      :show-delete="false"
      :show-save="true"
      :show-cancel="false"
      :show-page-cancel="true"
      :show-print="true"
      :show-new="false"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column m-3">
        <div class="grid">
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Revenue Accounts (Income)</p>
                  <div class="columns"
                    v-for="(type, value) in incomeCategoryTypes"
                    :key="value">
                    <label class="column">{{ type }}</label>
                    <div class="control column">
                      <div class="select is-fullwidth ">
                        <select v-model="getGLRouting(value).account">
                          <option value=""
                            disabled>Select</option>
                          <option v-for="acc in incomeAccounts"
                            :key="acc.account"
                            :value="acc.account">{{ acc.accountID }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Export Income Accounts</p>
                  <div class="columns"
                    v-for="(type, value) in incomeCategoryTypes"
                    :key="value">
                    <div class="column is-one-fifth">
                      <vue-numeric class="input has-text-right no-radius"
                        v-model="getGLRouting(value).exportAccount"
                        :min="0"
                        :max="99999"
                        :precision="0"
                        :separator="''"
                        :currency="''"
                        v-focus-inserted
                        :maxlength="5" />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <div class="grid">
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Expense Accounts</p>
                  <div class="columns"
                    v-for="(type, value) in expenseCategoryTypes"
                    :key="value">
                    <label class="column">{{ type }}</label>
                    <div class="control column">
                      <div class="select is-fullwidth ">
                        <select v-model="getGLRouting(value).account">
                          <option value=""
                            disabled>Select</option>
                          <option v-for="acc in expenseAccounts"
                            :key="acc.account"
                            :value="acc.account">{{ acc.accountID }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Export Expense Accounts</p>
                  <div class="columns"
                    v-for="(type, value) in expenseCategoryTypes"
                    :key="value">
                    <div class="column is-one-fifth">
                      <vue-numeric class="input has-text-right no-radius"
                        v-model="getGLRouting(value).exportAccount"
                        :min="0"
                        :max="99999"
                        :precision="0"
                        :separator="''"
                        :currency="''"
                        v-focus-inserted
                        :maxlength="5" />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <div class="grid">
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Banking Accounts (Asset)</p>
                  <div class="columns"
                    v-for="(type, value) in assetCategoryTypes"
                    :key="value">
                    <label class="column">{{ type }}</label>
                    <div class="control column">
                      <div class="select is-fullwidth ">
                        <select v-model="getGLRouting(value).account">
                          <option value=""
                            disabled>Select</option>
                          <option v-for="acc in assetAccounts"
                            :key="acc.account"
                            :value="acc.account">{{ acc.accountID }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div class="cell is-col-span-1 is-flex" />
        </div>
        <div class="grid">
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Other Accounts</p>
                  <div class="columns"
                    v-for="(type, value) in otherCategoryTypes"
                    :key="value">
                    <label class="column">{{ type }}</label>
                    <div class="control column">
                      <div class="select is-fullwidth ">
                        <select v-model="getGLRouting(value).account">
                          <option value=""
                            disabled>Select</option>
                          <option v-for="acc in getAccountList(type)"
                            :key="acc.account"
                            :value="acc.account">{{ acc.accountID }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div class="cell is-col-span-1 is-flex" />
        </div>
        <div class="grid">
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">GST</p>
                  <div class="columns"
                    v-for="(type, value) in gstCategoryTypes"
                    :key="value">
                    <label class="column">{{ type }}</label>
                    <div class="control column">
                      <div class="select is-fullwidth ">
                        <select v-model="getGLRouting(value).account">
                          <option value=""
                            disabled>Select</option>
                          <option v-for="acc in getAccountList(type)"
                            :key="acc.account"
                            :value="acc.account">{{ acc.accountID }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div class="cell is-col-span-1 is-flex" />
        </div>
        <div class="grid">
          <div class="cell is-col-span-1 is-flex">
            <article class="tile is-vertical is-child box">
              <div class="columns">
                <div class="column">
                  <p class="title">Payroll Defaults</p>
                  <div class="columns"
                    v-for="(type, value) in payrollCategoryTypes"
                    :key="value">
                    <label class="column">{{ type }}</label>
                    <div class="control column">
                      <div class="select is-fullwidth ">
                        <select v-model="getGLRouting(value).account">
                          <option value=""
                            disabled>Select</option>
                          <option v-for="acc in liabilityAccounts"
                            :key="acc.account"
                            :value="acc.account">{{ acc.accountID }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div class="cell is-col-span-1 is-flex" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import { AppHeaderButtonTypes } from '@/enums'
import GLMappingService from '@/services/GLMappingService'
import { GlAccountTypes, GlCategoryTypes } from '../../enums'
import _cloneDeep from 'lodash.clonedeep'
import {
  IncomeGLCategoryTypes,
  ExpenseGLCategoryTypes,
  OtherGLCategoryTypes,
  AssetGLCategoryTypes,
  GSTGLCategoryTypes,
  PayrollGLCategoryTypes
} from './GLMappingTypes'
import { KeyValuePairModel } from '../../classes/viewmodels'
import PrintPreviewRoutes from '../../components/printpreview/route-types'
import { Emailer } from '../../classes'
import HttpStatus from '../../components/http-status'
import StoreMixin from './storeMixin.js'
import VueNumeric from '../../components/VueNumeric/vue-numeric.vue'
import { FocusInserted } from '@/components/directives'

export default {
  name: 'GLMappingView',
  directives: {
    FocusInserted
  },
  components: {
    AppDetailHeader,
    VueNumeric
  },
  mixins: [StoreMixin],
  data() {
    return {
      glRoutingList: null,
      glAccountList: null
    }
  },
  computed: {
    glCategoryTypes() {
      return GlCategoryTypes
    },
    incomeCategoryTypes() {
      return IncomeGLCategoryTypes
    },
    expenseCategoryTypes() {
      return ExpenseGLCategoryTypes
    },
    assetCategoryTypes() {
      return AssetGLCategoryTypes
    },
    otherCategoryTypes() {
      return OtherGLCategoryTypes
    },
    gstCategoryTypes() {
      return GSTGLCategoryTypes
    },
    payrollCategoryTypes() {
      return PayrollGLCategoryTypes
    },
    incomeAccounts() {
      if (!this.glAccountList) return []
      return this.glAccountList.filter((a) => a.accountType === GlAccountTypes.Income)
    },
    expenseAccounts() {
      if (!this.glAccountList) return []
      return this.glAccountList.filter((a) => a.accountType === GlAccountTypes.Expenses || a.accountType === GlAccountTypes.CostOfSales)
    },
    assetAccounts() {
      if (!this.glAccountList) return []
      return this.glAccountList.filter((a) => a.accountType === GlAccountTypes.Assets)
    },
    liabilityAccounts() {
      if (!this.glAccountList) return []
      return this.glAccountList.filter((a) => a.accountType === GlAccountTypes.Liabilities)
    },
    equityAccounts() {
      if (!this.glAccountList) return []
      return this.glAccountList.filter((a) => a.accountType === GlAccountTypes.Equity)
    }
  },
  async created() {
    await this.getEntity()
  },
  methods: {
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.Save:
          this.save()
          break
        case AppHeaderButtonTypes.Print:
          this.print()
          break
        case AppHeaderButtonTypes.PageCancel:
          this.pageCancel()
          break
      }
    },
    async getEntity() {
      this.$showSpinner()
      this.glRoutingList = _cloneDeep(await this.getStoreItem({ serviceFunction: 'getGLRoutingList' }))
      this.glAccountList = _cloneDeep(await this.getStoreItem({ serviceFunction: 'getGlAccountList' }))
      this.glAccountList = this.glAccountList.map((acc) => ({
        ...acc,
        accountID: acc.account + ' ' + acc.name
      }))
      this.$hideSpinner()
    },
    getGLRouting(category) {
      if (!category || !this.glRoutingList) return {}
      const glRouting = this.glRoutingList.find((a) => a.glCategory === category)
      if (!glRouting) return {}
      if (glRouting.account == null || glRouting.account === '') {
        glRouting.account = 0
      }
      if (glRouting.exportAccount == null || glRouting.exportAccount === '') {
        glRouting.exportAccount = 0
      }
      return glRouting ? glRouting : {}
    },
    getIncomeExportAccount(accountId) {
      if (!accountId || !this.incomeAccounts) return ''
      const account = this.incomeAccounts.find((a) => a.account === accountId)
      return account ? account.exportAccount : ''
    },
    getExpenseExportAccount(accountId) {
      if (!accountId || !this.expenseAccounts) return ''
      const account = this.expenseAccounts.find((a) => a.account === accountId)
      return account ? account.exportAccount : ''
    },
    getAccountList(category) {
      if (!category) return []
      switch (category) {
        case OtherGLCategoryTypes.AP:
        case GSTGLCategoryTypes.GST_COL:
        case GSTGLCategoryTypes.TAXWH_ACC:
          return this.liabilityAccounts
        case OtherGLCategoryTypes.PROF:
          return this.equityAccounts
        case OtherGLCategoryTypes.GL_PU_ACC:
          return this.expenseAccounts
        default:
          return this.assetAccounts
      }
    },
    async save() {
      try {
        this.$showSpinner('Saving...')
        this.saveSnapshot(_cloneDeep(this.glRoutingList))
        const title = 'GL Mapping'
        var response
        if (this.snapshotDiff) {
          response = await GLMappingService.saveGLRouting(_cloneDeep(this.glRoutingList), this.response)
          if (response) {
            this.$notification.openNotificationWithType('success', title, 'Save successful')
          } else {
            this.$notification.openNotificationWithType('danger', title, 'Save failed')
          }
          await this.getEntity()
        } else {
          this.$notification.openNotificationWithType('warning', title, 'No changes. Not saved')
          return false
        }
        if (this.isSaveContinue) {
          this.$notification.openNotificationWithType('success', title, 'Save successful')
        }
        return true
      } catch (e) {
        if (e.response.request.status === HttpStatus.CONFLICT) {
          this.isSaveConflictModalActive = true
        } else {
          this.$notification.openMessageXhrError('', e)
        }
        return false
      } finally {
        this.$hideSpinner()
      }
    },
    print() {
      const reportName = 'rptAdminAccountGLMapping'
      let params = Object.assign({
        CompanyID: this.$userInfo.companyId
      })

      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      this.addReportParameters(keyValuePairs)

      const emailer = new Emailer()
      emailer.subject = 'GL Mapping Data'
      emailer.reportName = reportName
      this.addEmailer(emailer)

      this.$router.push({
        name: PrintPreviewRoutes.PrintPreview.name,
        params: { reportName: reportName },
        query: { parameterId: this.$guid.newGuid(), emailerId: emailer.id }
      })
    },
    async pageCancel() {
      await this.getEntity()
    }
  }
}
</script>